// Admin dashboard overview query. Gated on the platform role, not on scope:
// admin data belongs to the platform, not to the selected workspace (plan §2.2).
import { useQuery } from '@tanstack/react-query';

import { useIsPlatformAdmin } from '../../../shared/scope/useCurrentScope.js';

import { getAdminOverview, getAdminOverviewQueryKey } from '../api/admin.client.js';

/** Auto-refresh window for the live worker dashboard (30s). */
const OVERVIEW_REFETCH_INTERVAL_MS = 30_000;

export function useAdminOverview(periodDays = 7) {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminOverviewQueryKey(periodDays),
    queryFn: () => getAdminOverview(periodDays),
    enabled: isPlatformAdmin,
    refetchInterval: OVERVIEW_REFETCH_INTERVAL_MS,
  });
}
